import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from '../contexts/LanguageContext';
import '../styles/CoverScreen.css';

const CoverScreen = ({ onStart, onMultiplayer, onLogin, onOpenAbout, onOpenLobbyChat, onOpenSettings, onOpenAssistant, onOpenTroubleshooter, onOpenAccount }) => {
  const { user, isAuthenticated, isGuest } = useAuth();
  const { t, language, setLanguage, languages, getCurrentLanguage } = useTranslation();
  const [showLanguageMenu, setShowLanguageMenu] = useState(false);

  const handleLanguageSelect = (langCode) => {
    setLanguage(langCode);
    setShowLanguageMenu(false);
  };

  const currentLang = getCurrentLanguage();

  return (
    <div className="cover-screen">
      <div className="cover-background"></div>
      
      <div className="cover-content">
        <h1 className="cover-title">
          {t('cover.title')}
          <span className="cover-subtitle-line">
            <span className="cover-subtitle">{t('cover.subtitle')}</span>
            <span className="cover-subtitle-divider">:</span>
            <span className="cover-subtitle">{t('cover.riseOfDukes', 'Rise of the Dukes')}</span>
          </span>
        </h1>
        
        <div className="cover-buttons">
          <button className="cover-enter-btn" onClick={onLogin}>
            {t('cover.enter')}
          </button>
          
          <button className="cover-about-btn" onClick={onOpenAbout}>
            {t('cover.aboutUs')}
          </button>
          
          {/* Language Selector */}
          <div className="language-selector-container">
            <button 
              className="language-selector-btn"
              onClick={() => setShowLanguageMenu(!showLanguageMenu)}
            >
              <span className="lang-flag">{currentLang.flag}</span>
              <span className="lang-name">{currentLang.name}</span>
              <span className="lang-arrow">{showLanguageMenu ? '▲' : '▼'}</span>
            </button>
            
            {showLanguageMenu && (
              <div className="language-menu">
                {languages.map(lang => (
                  <button
                    key={lang.code}
                    className={`language-option ${language === lang.code ? 'active' : ''}`}
                    onClick={() => handleLanguageSelect(lang.code)}
                  >
                    <span className="lang-flag">{lang.flag}</span>
                    <span className="lang-name">{lang.name}</span>
                    {language === lang.code && <span className="lang-check">✓</span>}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        
        <div className="cover-tagline">
          {t('cover.tagline')}
        </div>
      </div>
    </div>
  );
};

export default CoverScreen;